import { createSelector } from '@reduxjs/toolkit';
import { selectTravelType, selectTravelTime } from 'shared/selectors/jsonQuery';
import { EMetroTravelType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Пешком', value: EMetroTravelType.MapFoot },
  { label: 'Транспортом', value: EMetroTravelType.MapTransport },
];

export const selectUndergroundTimeBusinessFilter = createSelector(
  [selectTravelType, selectTravelTime],
  (travelType, travelTime) => ({
    label: 'Расстояние до метро',
    options: OPTIONS,
    value: [travelType ?? null],
    time: travelTime,
  }),
);
